import { HttpClient } from '@angular/common/http';
import { AppConfigSettings } from '@arc/arc-shared-frontend';
import {
  StripeGuestCheckoutService,
  StripePaymentLinksService,
  StripePlatformService,
  StripeService,
} from '../services';
import { Injectable } from '@angular/core';

export const stripeServiceFactory = (
  httpClient: HttpClient,
  appConfig: AppConfigSettings,
) => {
  let service: StripeService;

  if (appConfig.getconfig('usePaymentLinkEndpoints') === 'true') {
    service = new StripePaymentLinksService(httpClient, appConfig);
  } else if (appConfig.getconfig('useHostedPaymentsPageEndpoints') === 'true') {
    service = new StripeGuestCheckoutService(httpClient, appConfig);
  } else {
    service = new StripePlatformService(httpClient, appConfig);
  }

  return service;
};

@Injectable({
  providedIn: 'root',
})
export class StripeServiceFactory {
  constructor(
    private httpClient: HttpClient,
    private appConfig: AppConfigSettings,
  ) {}

  create() {
    return stripeServiceFactory(this.httpClient, this.appConfig);
  }
}
